import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { OrderItems } from '@spike/order-model';
import Pet from '@spike/pet-model';
import clsx from 'clsx';
import PetCard from 'components/UI/PetCard';
import { Moment } from 'moment-timezone';
import { FunctionComponent } from 'react';

export interface DateProps {
    date: Moment;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            padding: '7px 10px',
            borderRadius: 5,
            backgroundColor: '#F8F5F1'
        },
        text: {
            fontSize: 16,
            lineHeight: '100%',
            fontWeight: 600
        }
    })
);

export const Date: FunctionComponent<DateProps> = props => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Typography className={classes.text}>{props.date.clone().format('dddd, D MMM YYYY')}</Typography>
        </Box>
    );
};

export default Date;
